const en = [{
  label: 'Period of time',
  name: 'date',
  type: 'range',
}, {
  label: 'Show downloaded invoices',
  name: 'download',
  type: 'section',
  options: [
    { name: 'All', value: '' },
    { name: 'Yes', value: '1' },
    { name: 'No', value: '0' },
  ]
}, {
  label: 'Show paid invoices',
  name: 'download',
  type: 'section',
  options: [
    { name: 'All', value: '' },
    { name: 'Yes', value: '1' },
    { name: 'No', value: '0' },
  ]
}, {
  label: 'Warehouse',
  name: 'warehousesIds',
  type: 'multiSelect',
  options: []
}]

const pl = [{
  label: 'Okres czasu',
  name: 'date',
  type: 'range'
}, {
  label: 'Pokaż pobrane faktury',
  name: 'download',
  type: 'section',
  options: [
    { name: 'Wszystkie', value: '' },
    { name: 'Tak', value: '1' },
    { name: 'Nie', value: '0' },
  ]
}, {
  label: 'Pokaż opłacone faktury',
  name: 'isPaid',
  type: 'section',
  options: [
    { name: 'Wszystkie', value: '' },
    { name: 'Tak', value: '1' },
    { name: 'Nie', value: '0' },
  ]
}, {
  label: 'Magazyn',
  name: 'warehousesIds',
  type: 'multiSelect',
  options: []
}]

export { en, pl }